<!--
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 选择支付渠道
 * @Date: 2021-09-07 16:18:02
 * @LastEditTime: 2022-02-28 16:55:26
-->
<template>
  <div class="money" :class="{ 'box-money': !showHeader }">
    <div class="payTypes" :class="boxClassName">
      <!-- 导航 -->
      <Header v-if="showHeader" :config="headConfig" />
      <div class="space" />
      <!-- 顶部支付说明信息 -->
      <ActiveContent :state="state.rebateForm" :active-names="activeNames" />
      <!-- Payment Method -->
      <div class="payTypes-payment">
        <!-- 标题 -->
        <div class="payTypes-payment-title ml-10 mr-10 pt-15 pb-5">
          Payment Method
        </div>

        <!-- 联系我们 -->
        <!-- <van-notice-bar
          left-icon="warning"
          background="#F1F1FF"
          color="#1E183F"
          class="notice-bar"
        >
          <span>If the best payment method works for you is not in the list below,
            please<a class="text-main" @click="contactUs"> contact us</a>.</span>
        </van-notice-bar> -->
        <van-notice-bar
          left-icon="warning"
          background="#fef5ec"
          color="#F99945"
          class="notice-bar els-tips"
        >
          <span>Please do not use credit card issued by the bank in Russia, it has been banned in international transactions.</span>
        </van-notice-bar>

        <!-- 支付渠道列表 -->
        <payList
          :select-pay-info="selectPayInfo"
          :recharge-form="rechargeForm"
          @select="changePay"
          @changePromoCode="changePromoCode"
          @getPromoReward="getPromoReward"
          @getValidType="getValidType"
        />
      </div>
    </div>

    <div class="pay-fixed-bottom">
      <!-- 支付渠道说明信息 -->
      <PayBottomInfo
        :detail="selectPayInfo"
        :max-amount="state.maxAmount"
        :change-flag="changeFlag"
        @contactUs="contactUs"
      />

      <!-- 支付金额 -->
      <div class="pay-box mt-10 flex flex-direction">
        <!-- 支付金额输入框 -->
        <div
          v-show="selectPayInfo.type !== 'BANK'"
          class="pay-form ml-10 mr-10"
        >
          <van-form
            class="pay-form-box margin-auto justify-between flex-direction-row"
            @submit="rechargeSubmit"
          >
            <van-field
              id="paymentInput"
              v-model="rechargeForm.money"
              left-icon="$"
              required
              class="pay-input"
              size="small"
              :style="{
                float: selectPayInfo.type === 'PAY_PAL' ? 'none' : 'left',
              }"
              autofocus
              :formatter="checkMoney"
              format-trigger="onBlur"
              type="number"
              placeholder="Please enter the payment amount"
              @focus="focusPayInput"
              @update:model-value="changePayValue"
              @blur="blurPayValue"
            />
            <!-- 支付金额校验信息提示卡片 -->
            <payIdenfy
              v-if="selectPayInfo.type === 'PAY_PAL'"
              :min-amount="state.minAmount"
              :select-pay-info="selectPayInfo"
              :recharge-form="rechargeForm"
              :max-amount="state.maxAmount"
            />

            <van-button
              v-show="!selectPayInfo.hideBtn"
              size="small"
              native-type="submit"
              class="pay-obn"
              @click="clickBtn"
            >
              Payment
            </van-button>
          </van-form>
          <div
            v-show="state.selectPay === 'PAY_PAL'"
            id="paypal-button-container"
            class="paypal-button mt-10"
          />
        </div>

        <!-- 银行支付场景:信息说明卡片 -->
        <Bank v-show="selectPayInfo.type === 'BANK'" />

        <!-- 银行支付场景:信息说明卡片 -->
        <!-- <Payoneer v-show="selectPayInfo.type === 'PAYONEER'" /> -->

        <!-- 手动输入表单 -->
        <ManualSubmitForm ref="manual_submit_form_ref" />

        <!-- 嵌入式支付页面 -->
        <EmbedPage ref="embed_page_ref" />

        <!-- 支付金额校验信息提示卡片 -->
        <payIdenfy
          v-if="selectPayInfo.type !== 'PAY_PAL'"
          :money-info="state"
          :select-pay-info="selectPayInfo"
          :recharge-form="rechargeForm"
        />
      </div>
    </div>

    <!-- 联系我们组件 -->
    <ContactUs ref="contactRef" />

    <!-- 支付确认框组件   -->
    <payConfirm
      :show="state.completeDialogShow"
      @confirm="onComfirmCompletedClick"
      @closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import {
  reactive,
  ref,
  computed,
  inject,
  onMounted,
  onUnmounted,
  watch,
  provide
} from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import { getPayInfo, getPayOrderStatus, createOrder } from 'model/campaign'
import { payTypeListInfo } from './data'

// 业务组件
import PayBottomInfo from './payBottomInfo'
import Bank from './bank.vue'
import Payoneer from './payoneer.vue'
import payConfirm from './payConfirm.vue'
import payIdenfy from './payIdenfy'
import payList from './payList'
import ManualSubmitForm from './ManualSubmitForm.vue'
import EmbedPage from './component/EmbedPageType/index.vue'
import { checkMoney } from 'utils/checkForm'
import { usePromoCode } from 'model/campaign'
import ActiveContent from './component/ActiveContent/index.vue'

const ColorStyle = [
  'replenish-item__price__first',
  'replenish-item__price__second',
  'replenish-item__price__third',
  'replenish-item__price__fourth'
]
export default {
  name: 'PayTypes',
  components: { PayBottomInfo, Bank, Payoneer, payConfirm, payIdenfy, payList, ManualSubmitForm, ActiveContent, EmbedPage },
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    //公共顶部配置文件
    const headConfig = {
      type: 'other',
      title: 'Add Money',
    }

    const notify = inject('$notify')
    const store = useStore()
    const contactRef = ref(null)
    const router = useRouter()
    const route = useRoute()
    const _ = inject('_')
    //检查订单状态定时器
    let checkCompleteTimer = null

    //充值金额
    const rechargeForm = reactive({
      money: store.state.dashboard.needMoney,
      realMoney: '',
      activeRate: 0, //活动率
      promoCode: null,
      totalMoney: null,
      valid: false,
      validErrorType: '',
      validType: 'input',
    })

    const state = reactive({
      paypalLoaded: false, //paypal 支付锁
      minAmount: 20,
      moreInfo: false,
      rebateForm: {
        isOpen: false,
      }, //顶部信息
      selectPay: null, //选中的制度方式
      completeDialogShow: false, //支付订单弹出框
      orderId: '', //当前待支付订单
      pmId: '',
      newTab: null, //新的窗口
      maxAmount: 0,
      promoReward: 0,
      isClickBtn: false,
      needJumpOrder: store.state.dashboard.needJumpOrder
    })

    provide('ProvideIsJump', state.needJumpOrder)

    const changeFlag = ref(false)

    const manual_submit_form_ref = ref(null)

    /** 嵌入式支付弹窗ref */
    const embed_page_ref = ref(null)

    /****切换支付方式 */
    const changePay = (data, amount) => {
      state.selectPay = data
      state.maxAmount = amount
      changeFlag.value = !changeFlag.value
      state.isClickBtn = false
    }

    // 修改promo code
    const changePromoCode = (code = null) => {
      rechargeForm.promoCode = code
    }

    /****联系我们 */
    const contactUs = () => {
      contactRef.value.open()
    }

    /**** 获取当前支付渠道具体信息 */
    const selectPayInfo = computed(() => {
      const ret = payTypeListInfo.find((i) => i.type === state.selectPay)
      if (ret) {
        return ret
      } else {
        return payTypeListInfo[0]
      }
    })

    /**** 动态计算可滚动容器值 */
    const boxClassName = computed(() => {
      let tem = ''
      switch (state.selectPay) {
        case 'PACY_PAY':
          tem = props.showHeader ? 'third-box' : 'third-box-x'
          break
        case 'BANK':
          tem = props.showHeader ? 'forth-box' : 'forth-box-x'
          break
        case 'STRIPE':
          tem = props.showHeader ? 'one-box' : 'one-box-x'
          break
        case 'PAY_PAL':
          tem = props.showHeader ? 'fifth-box' : 'fifth-box-x'
          break
        // case 'PAYONEER':
        //   tem = props.showHeader ? 'forth-box' : 'forth-box-x'
        //   break
        default:
          tem = props.showHeader ? 'two-box' : 'two-box-x'
      }
      return tem
    })
    const blurPayValue = async (event) => {
      rechargeForm.money = event.target.value < 20 ? '20' : event.target.value
    }
    /****获取充值真实金额以及提成 */
    //外部获取rate
    const changePayValue = async (value) => {
      rechargeForm.validType = 'input'
      if (state?.isClickBtn) {
        state.isClickBtn = false
      }
      if (value) {
        await validPromoCode()
      }
      const { isOpen, rewardList } = state.rebateForm
      //每次输入值变化，则reward清空
      if (value && isOpen && rewardList.length > 0) {
        let rate = 0
        for (let i = 0 ; i < rewardList.length ; i++) {
          const item = rewardList[i]
          const min = parseInt(item.min) / 100
          const max = parseInt(item.max) / 100
          const values = Number(value)
          if (i === 0 && values >= min && values <= max) {
            rate = item.rate
          } else if (values > min && values <= max || values > max) {
            rate = item.rate
          }
        }

        if (rate > 0) {
          rechargeForm.realMoney = (
            rechargeForm.money *
            (rate / 100 + 1)
          ).toFixed(2)
          rechargeForm.activeRate = rate
        } else {
          rechargeForm.realMoney = ''
          rechargeForm.activeRate = 0
        }
        if (state.promoReward) {
          getTotalReceived()
        }
        getTotalReceived()
      } else if (!value) {
        state.promoReward = 0
      }
    }

    /**** api: 获取顶部支付说明信息 */
    const queryPayInfo = async () => {
      let list = {}
      // if(!list){

      const re = await getPayInfo()
      if (re.code === 0) {
        const { desc, isOpen, step, rate, replenishActivityIsOpen, eTime, subject, content } = re.data
        list.rewardList = []
        list.desc = desc
        list.isOpen = isOpen
        list.replenishActivityIsOpen = replenishActivityIsOpen || false
        list.eTime = eTime
        const rebateForm = []
        const newArr = []
        const arrTrans = function (num, arr) {
          for (let i = 0; i < arr.length; i++) {
            const arrays = [...arr]
            newArr.push(arrays.splice(i, num))
          }
          return newArr.splice(-1)
        }
        arrTrans(2, step)
        newArr.forEach((item, index) => {
          const obj = {
            min: item[0].toString(),
            max: item[1].toString(),
            rate: rate[index].toString(),
            subject: subject ? subject[index] || '' : '',
            content: content ? content[index] || '' : ''
          }
          rebateForm.push(obj)
        })
        list.rewardList = rebateForm
        // store.dispatch('savePayInfo',list)
      }
      // }
      state.rebateForm = list
    }

    /****api:创建支付订单 */
    const createOrderId = async () => {
      try {
        const orderId = await createOrder({
          currencyType: selectPayInfo.value?.coinType || 'USD',
          amount: parseInt(rechargeForm.money * 100),
          promoCode: rechargeForm.promoCode,
        })

        if (orderId) {
          state.orderId = orderId
        }
        return orderId
      } catch (error) {
        console.error('createOrderId', error)
      }
    }

    /****api:获取当前订单的支付结果 */
    const checkCompleted = async () => {
      if (!state.orderId) {
        return false
      }
      const res = await getPayOrderStatus({
        orderId: state.orderId,
      })
      if (res && res.boolRet === true) {
        state.completeDialogShow = false
        const id = state.orderId
        state.orderId = ''
        await store.dispatch('user/getBalance')
        emit('onPayCompleted', state.orderId)
        if (route.path === '/wap/money') {
          router.push({
            name: 'Transactions',
            params: {
              rechargeOrderId: id
            }
          })
        }
        if (route.path === '/wap/campaign') {
          if(route.query.serviceType === 'ASO_SERVICE') {
            return 
          }
          // window.location.assign('/wap/order')
          router.push('/wap/order')
        }
        return true
      }
      return false
    }

    /****关闭轮询/初始化订单号 **/
    const closeOrderStatus = () => {
      state.orderId = ''
      state.completeDialogShow = false
      clearInterval(checkCompleteTimer)
    }

    /****开启支付状态轮询 **/
    const startCheckOrderStatus = () => {
      checkCompleteTimer = setInterval(async () => {
        if (state.completeDialogShow && state.orderId) {
          const re = await checkCompleted()
          re && clearInterval(checkCompleteTimer)
        }
      }, 1000)
    }

    /**
     * @description: 聚焦支付金额输入框
     */
    const focusPayInput = async () => {
      const event = selectPayInfo.value.focusEvent
      if (event) event()
    }

    /****api:发起支付请求 **/
    const rechargeSubmit = async () => {
      //校验
      if (
        !rechargeForm.money ||
        rechargeForm.money < 20 ||
        (state.maxAmount && rechargeForm.money > state.maxAmount)
      ) {
        return
      }
      //关闭轮询
      closeOrderStatus()

      // 检查激活 后续做
      try {
        await store.dispatch('user/triggerActive')
      } catch (e) {
        return
      }
      //创建订单/并且打开支付界面
      if (selectPayInfo.value.onPayType === 'ManualForm') {
        manual_submit_form_ref.value.open(handleManualSubmit)
      } else if (selectPayInfo.value.onPayType === 'EmbedPage') {
        console.log('EmbedPage')
        await selectPayInfo.value.onPay(state, embed_page_ref, createOrderId)
      } else {
        openNewPageForPay(state)
      }

      //开启支付结果状态轮询
      startCheckOrderStatus()
    }

    const handleManualSubmit = (form) => {
      openNewPageForPay(state, form)
    }

    const openNewPageForPay = async (s, form) => {
      //创建订单/并且打开支付界面
      state.newTab = window.open()
      if (await createOrderId()) {
        state.pmId = selectPayInfo.value.pmId
        if (await selectPayInfo.value.onPay.call(this, s, form)) {
          state.completeDialogShow = true
        }
      }
    }

    //确认支付结果
    const onComfirmCompletedClick = async () => {
      if (!(await checkCompleted())) {
        return notify({
          type: 'warning',
          message: 'No payment result was found, please try again.',
        })
      }
      state.completeDialogShow = false
      emit('onPayCompleted', state.orderId)
    }

    //初始化操作
    const init = async () => {
      //获取支付说明信息
      await queryPayInfo()
      //获取支付方式
      //   await getPayTypes()

      //查询订单状态
      state.orderId && startCheckOrderStatus()
    }

    //执行初始化
    init()
    onMounted(() => {
      if (rechargeForm.money) {
        setTimeout(() => {
          // rechargeForm.money 小于20 时默认为20
          if (rechargeForm.money < 20) {
            rechargeForm.money = 20
          }
          changePayValue(rechargeForm.money)
        }, 200)
      }
    })
    onUnmounted(() => {
      clearInterval(closeOrderStatus())
    })
    const closeDialog = () => {
      state.completeDialogShow = false
    }
    const activeNames = ref(['1'])
    const status = ref(false)

    //获取优惠码金额
    const getPromoReward = (val) => {
      state.promoReward = val
    }
    //获取汇总金额
    const getTotalReceived = () => {
      const rewardMoney = state.promoReward ? state.promoReward : 0
      rechargeForm.totalMoney = rechargeForm.money
        ? rechargeForm.realMoney
          ? (
            rechargeForm.money * (rechargeForm.activeRate / 100 + 1) +
              rewardMoney
          ).toFixed(2)
          : (Number(rechargeForm.money) + Number(rewardMoney)).toFixed(2)
        : null
    }
    //监听支付获取值，重新计算当前realMoney
    watch(
      () => state.promoReward,
      () => {
        getTotalReceived()
      }
    )
    //是否点击payment按钮
    const clickBtn = () => {
      state.isClickBtn = true
    }

    const validPromoCode = async () => {
      if (!rechargeForm.promoCode || !rechargeForm.promoCode.length) {
        rechargeForm.valid = false
        return
      }
      const res = await usePromoCode({
        code: rechargeForm.promoCode ?? '',
        amount: Number(rechargeForm.money) * 100,
      })
      if (res.reward) {
        rechargeForm.valid = true
        rechargeForm.validErrorType = ''
        state.promoReward = res.reward / 100
      } else {
        rechargeForm.valid = false
        rechargeForm.validErrorType = res.codeError
        state.promoReward = 0
      }
    }
    //判断此时是点击校验还是输入校验
    const getValidType = (val) => {
      rechargeForm.validType = val
    }

    //节流
    const inputDebounce = _.debounce(changePayValue, 500, {
      leading: true, //立即执行
    })
    return {
      blurPayValue,
      manual_submit_form_ref,
      createOrderId,
      changePay,
      changePayValue,
      checkCompleteTimer,
      boxClassName,
      rechargeForm,
      checkMoney,
      focusPayInput,
      rechargeSubmit,
      state,
      headConfig,
      contactUs,
      contactRef,
      selectPayInfo,
      onComfirmCompletedClick,
      activeNames,
      status,
      changeFlag,
      closeDialog,
      changePromoCode,
      getPromoReward,
      clickBtn,
      validPromoCode,
      getValidType,
      inputDebounce,
      ColorStyle,
      embed_page_ref
    }
  },
}
</script>
<style lang="scss" scoped>
@import './index.scss';

.vant-title {
  text-align: left;
  color: $thinH2;
}

.vant-desc {
  color: $sign;
}

.text-main {
  text-decoration: underline;
}

.space {
  height: 8px;
  background: $bgColor;
}


.notice-bar {
  font-size: 12px;
  padding: 0 10px;
  margin: 0 0 15px;

  :deep(.van-notice-bar__left-icon) {
    font-size: 14px;
    color: #6153ff;
  }

  :deep(.van-notice-bar__right-icon) {
    font-size: 12px;
  }
}
.els-tips{
  :deep(.van-notice-bar__left-icon) {
    font-size: 14px;
    color:#F99945;
  }
}
.money {
  .van-form {
    :deep(.van-cell) {
      .van-cell__value {
        .van-field__body {
          input::-webkit-input-placeholder {
            /* WebKit browsers */
            font-size: 13px;
          }
          input:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            font-size: 13px;
          }
          input::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            font-size: 13px;
          }
          input::-ms-input-placeholder {
            /* Internet Explorer 10+ */
            font-size: 13px;
          }
        }
      }
    }
  }
}
// .notice-bar-els{
//     color:#F99945;
//     i{
//       font-size: 14px;
//       color: #6153ff;
//     }
//   }
</style>
